<template>
  <div class="overview">
      <div v-if="!isLoading" class="overview__wrapper">
        <div class="overview__wrapper__header">
            <h1 class="large-title title">Summary</h1>
        </div>
        <div class="overview__wrapper__content">
            <div class="overview__wrapper__content__details">
                <h2 class="small-title subtitle">Campaign Details</h2>
                <div class="overview__wrapper__content__details__campaign-name">
                    <span class="subtitle subhead">Campaign Name</span>
                    <span class="divider">:</span>
                    <span class="value subhead">{{campaign.campaign_title}}</span>
                </div>
                <div class="overview__wrapper__content__details__periods">
                    <span class="subtitle subhead">Periods</span>
                    <span class="divider">:</span>
                    <span class="value subhead">{{formatDate(campaign.start)}} - {{formatDate(campaign.end)}}</span>
                </div>
                <div class="overview__wrapper__content__details__periods">
                    <span class="subtitle subhead">Total listing</span>
                    <span class="divider">:</span>
                    <span class="value subhead">{{campaign.total_listing}}</span>
                </div>
            </div>
            <div class="overview__wrapper__content__details">
                <h2 class="small-title subtitle">Contents</h2>
                <div class="overview__wrapper__content__details__items">
                    <div v-if="selectedLandscape" class="overview__wrapper__content__details__items__landscape">
                        <a :href="selectedLandscapeUrl" target="_blank">
                            <img :src="selectedLandscape" alt="">
                        </a>
                    </div>
                    <div v-if="selectedPortrait" class="overview__wrapper__content__details__items__portrait">
                        <a :href="selectedPortraitUrl" target="_blank">
                            <img :src="selectedPortrait" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="overview__wrapper__content__details">
                <h2 class="small-title subtitle">Location and Price Detail</h2>
                <table class="table-devices">
                    <thead>
                        <th class="no">No</th>
                        <th class="items">Items</th>
                        <th class="price">Price / Day</th>
                        <th class="days">Days</th>
                        <th class="slot">Slot</th>
                        <th class="total">Total Price</th>
                    </thead>
                    <tbody>
                        <tr v-for="(price, index) in priceDetail.prices" :key="price.id">
                            <td class="no">{{index + 1}}</td>
                            <td>{{ price.device }}</td>
                            <td>
                                <div class="space">
                                <span class="subhead">{{ price.daily_price | formatMoney }}</span>
                                </div>
                            </td>
                            <td>{{ price.effective_days }}</td>
                            <td>{{ price.slot }}</td>
                            <td>
                                <div class="space">
                                <span class="subhead">{{ price.total | formatMoney }}</span>
                                </div>
                            </td>
                        </tr>
                        <tr class="total no-border">
                            <td colspan="4"></td>
                            <td class="total-bg large-font strong">Total</td>
                            <td class="total-bg">
                                <div class="space">
                                <span class="large-font strong">{{ priceDetail.total | formatMoney }}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </div>
      <div v-else class="overview__wrapper">
        <adx-loading />
      </div>
  </div>
</template>

<script>

import Loading from '@/components/Loading/Primary'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-campaign-overview',
  components: {
    'adx-loading': Loading,
  },
  props: {

  },
  data() {
    return {
        campaignId: null,
        campaign: {},
        contents: [],
        priceDetail: {},
        selectedLandscape: null,
        selectedPortrait: null,
        selectedLandscapeUrl: null,
        selectedPortraitUrl: null,
        isLoading: false,
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.loadData()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    formatDate (date) {
        if (date) {
            return formatShortDate(date)
        }
        return ` `
    },
    loadData() {
        this.campaignId = this.$route.params.id
        this.getCampaign()
    },
    getCampaign() {
        (async () => {
            this.isLoading = true
            const response = await api.get(apiV2.campaignOverview(this.campaignId), { needToken: true })
            if (response.status == 200) {
                this.campaign = response.data
                this.getContents()
            } else if(response.status == 404) {
                this.$router.push({ name: '404' })
            } else if(response.status == 403) {
                this.$router.push({ name: '403' })
            } else {
                this.$router.push({ name: '500' })
            }
        })();
    },
    getContents() {
        (async () => {

            const response = await api.get(apiV2.campaignContents(this.campaign.campaign_id), { needToken: true })

            if (response.status == 200) {
                this.contents = response.data
                const landscape = this.contents.filter(x => x.rotation === 0).pop()
                const portait = this.contents.filter(x => x.rotation === 90).pop()
                if (landscape) {
                    this.selectedLandscape = landscape.thumb
                    this.selectedLandscapeUrl = landscape.preview_url
                }
                if (portait) {
                    this.selectedPortrait = portait.thumb
                    this.selectedPortraitUrl = portait.preview_url
                }
                this.getPriceDetail()
            } else {
                // this.error = response.data.error
            }
        })();
    },
    getPriceDetail() {
        (async () => {

            const response = await api.get(apiV2.realPrice(this.campaign.campaign_id), { needToken: true })
            this.isLoading = false
            if (response.status == 200) {
                this.priceDetail = response.data
            } else {
                // this.error = response.data.error
            }
        })();
    },
    back() {
        window.history.back();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>